import {Injectable} from '@angular/core';
import {OktaAuth, TokenResponse} from '@okta/okta-auth-js';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OktaService {
  constructor(
    private readonly http: HttpClient,
    private readonly oktaAuth: OktaAuth
  ) {
  }

  async handleCallback(): Promise<void> {
    try {
      await this.oktaAuth.token
        .parseFromUrl()
        .then((res: TokenResponse) =>
          console.log('Tokens: ' + JSON.stringify(res.tokens))
        );
    } catch (err) {
      console.error('Okta handleCallback error:', err);
    }
  }
}
